import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Democratic Republic of the Congo`}</h3>
    <p>{`In 2019, the Democratic Republic of the Congo was the world’s second largest hunger crisis, after Yemen, with nearly 16 million living in acute food insecurity driven by armed conflict, displacement and the Ebola outbreak. In response, WFP rapidly scaled-up its food and nutrition assistance to reach nearly `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=CD01&year=2019#/14900"
      }}>{`7 million`}</a>{` people – and funding from the EU was crucial to help almost 2 million of them in the Kasai and Tanganyika regions with cash assistance.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      